import { Component, ViewEncapsulation } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng';
import { Router } from '@angular/router';
import { Message } from '../../classes/Message';
import { CellDataType } from '../../interfaces/data-import/cell-data-type';
import { IColumnDefinition } from '../../interfaces/data-import/column-definition';
import { DataImportService } from '../../services';

@Component({
  selector: 'import-config',
  templateUrl: './import-config.component.html',
  styleUrls: ['./import-config.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ImportConfigComponent {
  get firstRow(): number {
    return this.dataImportService.config.firstRow;
  }

  set firstRow(value: number) {
    if (value >= 0) {
      this.dataImportService.config.firstRow = value;
    }
  }

  get maxErrorsCount(): number {
    return this.dataImportService.config.maxErrorsCount;
  }

  set maxErrorsCount(value: number) {
    if (value >= 0) {
      this.dataImportService.config.maxErrorsCount = value;
    }
  }

  get columnDefinitions(): IColumnDefinition[] {
    return this.dataImportService.config.columnDefinitions;
  }

  set columnDefinitions(value: IColumnDefinition[]) {
    this.dataImportService.config.columnDefinitions = value;
  }

  dataTypes = DATA_TYPES;
  customValidationTypes = CUSTOM_VALIDATION_TYPES;

  selectedDef: IColumnDefinition;
  editingDef: IColumnDefinition;
  originalDef: IColumnDefinition;
  editingMode: EditingMode;
  dialogIsVisible: boolean;

  constructor(
    private dataImportService: DataImportService,
    private confirmationService: ConfirmationService,
    private router: Router,
    public messageService: MessageService,
  ) {
    this.dialogIsVisible = false;
  }

  addDef(): void {
    this.editingMode = 'add';
    this.editingDef = {
      orderNumber: this.columnDefinitions.length + 1,
      type: CellDataType.String,
      targetFieldName: '',
      isAllowNulls: true,
    };
    this.dialogIsVisible = true;
  }

  editDef(def: IColumnDefinition): void {
    this.editingMode = 'edit';
    this.originalDef = def; //this.selectedDef;
    this.editingDef = Object.assign({}, def);
    this.dialogIsVisible = true;
  }

  deleteDef(def: IColumnDefinition): void {
    this.confirmationService.confirm({
      message: 'Are you sure (Y/N) ?',
      accept: () => {
        this.columnDefinitions.splice(this.columnDefinitions.indexOf(def), 1);
        this.selectedDef = null;
        this.messageService.add(Message.Success('Data deleted.'));
      },
    });
  }

  commitEdit(): void {
    if (this.editingMode === 'add') {
      this.columnDefinitions.push(this.editingDef);
      this.selectedDef = this.editingDef;
      this.handleOrderNumber(this.editingDef);
    } else {
      Object.assign(this.originalDef, this.editingDef);
      this.handleOrderNumber(this.originalDef);
    }
    this.dialogIsVisible = false;
  }

  cancel() {
    this.router.navigate(['/app/drivers']);
  }

  finishEdit(): void {
    if (this.editingMode === 'edit') {
      this.originalDef = null;
    }
    this.editingMode = null;
    this.editingDef = null;
  }

  getCellDataTypeName(type: CellDataType): string {
    return this.dataTypes.find((item) => {
      return item.value == type;
    }).label;
  }

  private handleOrderNumber(def: IColumnDefinition) {
    for (let i = this.columnDefinitions.indexOf(def); i > 0; i--) {
      if (this.columnDefinitions[i].orderNumber <= this.columnDefinitions[i - 1].orderNumber) {
        swap(i - 1, i, this.columnDefinitions);
        this.columnDefinitions[i].orderNumber++;
      } else {
        break;
      }
    }
    for (let i = this.columnDefinitions.indexOf(def); i < this.columnDefinitions.length - 1; i++) {
      if (this.columnDefinitions[i].orderNumber >= this.columnDefinitions[i + 1].orderNumber) {
        swap(i, i + 1, this.columnDefinitions);
        this.columnDefinitions[i].orderNumber--;
      } else {
        break;
      }
    }

    function swap(i1: number, i2: number, collection: any[]) {
      let tmp = collection[i1];
      collection[i1] = collection[i2];
      collection[i2] = tmp;
    }

    this.messageService.add(Message.Success('Import Successful.'));
  }
}

type EditingMode = 'edit' | 'add';

const DATA_TYPES: { value: CellDataType; label: string }[] = [
  { value: CellDataType.String, label: 'String' },
  { value: CellDataType.Number, label: 'Number' },
  { value: CellDataType.Date, label: 'Date' },
  { value: CellDataType.Phone, label: 'Phone' },
  { value: CellDataType.Email, label: 'Email' },
  { value: CellDataType.Custom, label: 'Custom' },
  { value: CellDataType.Boolean, label: 'Boolean' },
];

const CUSTOM_VALIDATION_TYPES: { value: string; label: string }[] = [
  { value: 'JobRole', label: 'Job role' },
];
